<script lang="ts">
	import type { ComponentProps } from 'svelte';
	import Advertising from './Advertising.svelte';

	interface Props {
		type: 'native' | 'default';
	}

	const { type = 'default' }: Props = $props();

	const defaultAdProps = {
		adId: 'poi-list',
		adFormat: '300x250',
		showAdByDefault: true,
	} satisfies ComponentProps<typeof Advertising>;

	const nativeAdProps = {
		adId: 'poi-card-native-ad',
		adFormat: '1x1',
		showAdByDefault: true,
	} satisfies ComponentProps<typeof Advertising>;

	const usedAdProps = type === 'native' ? nativeAdProps : defaultAdProps;

	const containerStyle = type === 'native' ? 'size-auto' : 'h-70 w-75';
</script>

<div class={['flex items-center justify-center relative', containerStyle]}>
	<Advertising {...usedAdProps} />
</div>
